import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaCommentAlt } from 'react-icons/fa';

import './CommentsCountIcon.css';

const CommentsCountIcon = ({ children, linkTo }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e) => {
    if (linkTo.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(linkTo);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else if (location.pathname + location.hash === linkTo) {
      e.preventDefault();
      const hash = linkTo.split('#')[1];
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(linkTo);
    }
  };

  return (
    <button
      className='blog-post-card-comment-link'
      onClick={handleClick}
      style={{ all: 'unset' }}
    >
      <div className='blog-post-card-comment-count-icon-container'>
        <FaCommentAlt className='blog-post-card-comment-icon' />
        <span className='blog-post-card-comments-count'>{children}</span>
      </div>
    </button>
  );
};

export default CommentsCountIcon;
